/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Desk_Sso_Invalid_RefInputs */

const vi_error_desk_sso_invalid_ref = /** @type {(inputs: Error_Desk_Sso_Invalid_RefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã tham chiếu không hợp lệ. Vui lòng kiểm tra lại đường dẫn.`)
};

/**

* @param {Error_Desk_Sso_Invalid_RefInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_desk_sso_invalid_ref = /** @type {((inputs?: Error_Desk_Sso_Invalid_RefInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Desk_Sso_Invalid_RefInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_desk_sso_invalid_ref(inputs)
});